<script>
export default {
    name: "resetPassword",
    data() {
        return {
            oldPassword: '',
            newPassword: '',
            cNewPassword: '',
            isLoading: false,
        };
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {
        save() { 
            if(this.isLoading){
                return false;
            }
            if(this.oldPassword.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.oldPassword.focus();
                this.$showToast({ text: 'Please enter Old password' }); //请输入密码
                return false;
            }
            if(this.newPassword.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.newPassword.focus();
                this.$showToast({ text: 'Please enter New password' }); //请输入密码
                return false;
            }
            if(this.cNewPassword.replace(/(^\s*)|(\s*$)/g, "").length == 0){
                this.$refs.cNewPassword.focus();
                this.$showToast({ text: 'Please confirm the new password' }); //请输入密码
                return false;
            }
            if(this.newPassword != this.cNewPassword){
                this.$refs.cNewPassword.focus();
                this.$showToast({ text: 'The two password inputs are inconsistent' }); //两次密码输入不一致
                return false;
            }
            this.isLoading = true;
            this.$store.dispatch('resetPassword', {
                old_password: this.oldPassword,
                new_password: this.newPassword,
                confirm_password: this.cNewPassword
            }).then((result) => {
                this.isLoading = false;
                if (result.code == 100) { 
                    this.$showToast({ text: 'The password modification was successful.' }); //密码修改成功
                }
                else if (result.code == 101) {
                    this.$showToast({ text: 'The old password is incorrect.' }); //旧密码错误
                }
                else if (result.code == 102) {
                    this.$showToast({ text: 'The two password inputs are inconsistent' }); //两次密码输入不一致
                }
                else if (result.code == 90) { 
                    this.$router.replace({
                        path: '/login',
                        query: { redirect: this.$route.fullPath }
                    })
                }
            }).catch((err) => {
                this.isLoading = false;
            });
        },
    },
};
</script>

<template>
    <div class="resetPassword">
        <div class="title">Reset Password</div>
        <div class="wrapper flex">
            <div class="content">
                <div class="input_group">
                    <div class="name">Old Password</div>
                    <input type="password" name="oldPassword" ref="oldPassword" v-model="oldPassword"/>
                </div>
                <div class="input_group">
                    <div class="name">New Password</div>
                    <input type="password" name="newPassword" ref="newPassword" v-model="newPassword"/>
                </div>
                <div class="input_group">
                    <div class="name">Confirm New Password</div>
                    <input type="password" name="cNewPassword" ref="cNewPassword" v-model="cNewPassword"/>
                </div>
                <div class="btn flex_center" @click="save">Update Profile</div>
            </div>
            <div class="content"></div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.wrapper{
    gap: .2rem;
    @media only screen and (max-width: 750px) {
        gap: 0;
        flex-direction: column;
    }
    .content{
        flex: 1;
    }
    .title{
        font-size: .24rem;
        margin-bottom: .3rem;
    }
}
.input_group{
    margin-bottom: .25rem;
    .name{
        font-size: .16rem;
        color: #666;
        margin-bottom: .15rem;
        @media only screen and (max-width: 750px) {
            font-size: .24rem;
        }
    }
    input{
        width: 100%;
        height: .5rem;
        border: 1px solid #c9c9c9;
        background: #fff;
        border-radius: .05rem;
        padding: 0 .25rem;
        font-size: .16rem;
        outline: none;
        color: #666;
        box-sizing: border-box;
        @media only screen and (max-width: 750px) {
            font-size: .24rem;
        }
    }
}
.btn{
    font-size: .24rem;
    background: var(--background-color);
    color: var(--color-blue);
    width: 2.2rem;
    height: .4rem;
    border-radius: .4rem;
    cursor: pointer;
    font-weight: bold;
    @media only screen and (max-width: 750px) {
        margin: 0 auto;
        width: 2.8rem;
        height: .5rem;
        font-size: .28rem;
    }
}
</style>